/* eslint-disable @next/next/no-img-element */
// libraries
import { hifenUrl } from '../../../utils/hifenUrl';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import {
    getImoveisListCategoryStorageKey,
    getImoveisListCaracteristicasStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../../utils/storage';
import { appendCodsiteQuery } from '../../../utils/url';
import { genMetaEventId, trackMetaEvent } from '../../../utils/metaPixel';
import { getHeroVideoPoster, useHeroVideoReady } from '../../../utils/heroVideo';
import { useCidadeFixaBusca } from '../../../utils/cidadeFixaBusca';
import { useAuth, useRegiaoHref } from '../../context/Info';
import { useCidadesMulti } from '../../shared/city-multi/useCidadesMulti';
import DrawerComponent from '../../drawer/DrawerComponent';
import CardsBusca from '../../shared/cards-busca/CardsBusca';
// framer-motion REAL (não o lightMotion estático): fade-in no topo/busca pra esconder a
// renderização feia dos selects (ssr:false) sobre a caixa colorida. Custo aceito (Daniel 24/06).
import { motion } from 'framer-motion';
import FiltrosModalMobile from './FiltrosModalMobile';
import Mocks from './WelcomePieces.mocks';
import styles from './WelcomePieces.module.css';
import { usePreviaBuilder } from '../../../lib/previaBuilder';
const Select = dynamic(() => import('react-select'), { ssr: false });

// interface
export interface ISelectors {
    allCities: Array<{ label: string; value: string; id_estado: any }>;
    allTypes: any;
    allTransacao: Array<{ label: string; value: string }>;
    allCompany: Array<{ label: string; value: string }>;
    site: any;
    companyInputActual: any;
    setCompanyInputActual: any;
    setActiveDrawer: any;
    activeDrawer: any;
    origin?: any;
    codsite?: any;
    favorito: Array<number>;
    valores?: any;
    codsite2?: any;
    isMobile1?: Boolean;
    props: any;
    allCards: any;
    /**
     * BUSCA POR IA (modelo_busca = 12): slot opcional renderizado no TOPO do cartao de
     * busca, acima dos filtros classicos. Mesmo contrato do hero 1 (welcome/WelcomePieces),
     * usado pelo hero 10. Sem a prop, nada muda no hero 3 (os outros 17 tenants).
     */
    aiSearch?: (_ctx: {
        transacao: string;
        filtrosAbertos: boolean;
        onTransacaoChange: (_value: string) => void;
    }) => React.ReactNode;
}

type Banner = {
  ativo: boolean;
  titulo: string;
  url: string;
  url_link: string | null;
  message: string;
};

const WelcomePieces: React.FC<ISelectors> = ({
    allCities,
    allTypes,
    allCompany,
    allTransacao,
    site,
    companyInputActual,
    setCompanyInputActual,
    setActiveDrawer,
    activeDrawer,
    origin,
    codsite,
    favorito,
    valores,
    codsite2: _codsite2,
    isMobile1,
    props,
    allCards,
    aiSearch
}) => {
    const { videoParado } = usePreviaBuilder(); // prévia dos cards do CRM: vídeo parado na capa
    // Hero: pôster (leve) = LCP; vídeo (pesado) carrega só depois do LCP (só vídeos default).
    // Pôster: o do vídeo REGIONAL (quando o tenant enviou um) vence o derivado
    // dos vídeos default — vídeo custom sem pôster segue sem pôster, como hoje.
    const heroPoster = site?.url_video_poster || getHeroVideoPoster(site?.url_video);
    const heroVideoReady = useHeroVideoReady();
    // constants
    const {
        listCategory,
        setListCategory,
        listEstados,
        setListEstados,
        listCaracteristicas,
        setListCaracteristicas,
        listDatas,
        allDataHome,
        setListDatas
    } = useAuth();
    
    // Carousel state for banners
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
    const banners: Array<Pick<Banner, "url" | "url_link" | "message">> =
    (allDataHome?.allBanners ?? [])
        .filter((b: Banner) => b?.ativo && b?.titulo === "topo" && b?.url)
        .map(({ url, url_link, message }) => ({ url, url_link, message }));
    // .slice(0, 3) // <- se quiser no máximo 3
    const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const isSite2507 = Number(site?.id) === 2507;
    const isSite2523 = Number(site?.id) === 2523;
    const showHomeCategoria = Boolean(site?.categoria_home) && !isSite2507;
    const showHomeCaracteristicas = Boolean(site?.caracteristicas_home) && !isSite2507;
    const showHomeDormitorios = true;
    const allOptions = [{label: '1', value: 1},{label: '2', value: 2},{label: '3', value: 3},{label: '4', value: 4},{label: '5 +', value: 5}];
    const [allDistrict, setAllDistrict] = useState([]);
    const cidadesBaseBusca = useMemo(
        () => (site?.id == 2177 ? allCities.filter((city: any) => city?.id_estado == 24) : allCities),
        [allCities, site?.id]
    );
    const [allCitiesAux, setAllCitiesAux] = useState(cidadesBaseBusca);
    // MULTI-FILIAIS: acompanha a troca de filial (ver welcome/WelcomePieces).
    useEffect(() => {
        setAllCitiesAux(cidadesBaseBusca);
    }, [cidadesBaseBusca]);
    const [searchAdvanced, setSearchAdvanced] = useState<boolean>(site?.id == "2023" || site?.id == "1667" || site?.id == "2366" || site?.id == "2118" || site?.id == "2148" || site?.id == "278" ? true : false);
    const [citiesActual, setCitiesActual] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
    const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [categoryActual, setCategoryActual] = useState<any>([]);
    const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2177 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
    const [urlTipo, setUrlTipo] = useState<string>("");
    const [urlCaract, setUrlCaract] = useState<string>("");
    const [urlDatas, setUrlDatas] = useState<string>("");
    const [urlDistrict, setUrlDistrict] = useState<string>("");
    const [transacaoActual, setTransacaoActual] = useState<any>(allTransacao[0]);
    const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
    const [banheirosActual, setBanheirosAtual] = useState<any>();
    const [suitesActual, setSuitesAtual] = useState<any>();
    const [vagasActual, setVagasAtual] = useState<any>();
    const [codeActual, setCodeActual] = useState('');
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
    const isMobileView = Boolean(isMobile || isMobile1);

    // BUSCA AVANCADA EM MODAL (modelo_busca = 12). No celular a lista inline de 15 campos
    // ficava com ~894px numa tela de 844px e empurrava o BUSCAR para fora da vista, entao
    // aqui ela abre em tela cheia (ver `FiltrosModalMobile`). O breakpoint e' o MESMO 768px
    // que o `.module.css` ja usa. Estado calculado so depois da montagem, nao pelo UA: no
    // SSR e no primeiro paint vale `false`, logo a marcacao entregue continua identica a de
    // hoje e nao ha divergencia de hidratacao. Sem `aiSearch` (modelo 3 puro e demais heros)
    // nada disso liga.
    const [telaEstreita, setTelaEstreita] = useState<boolean>(false);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mq = window.matchMedia('(max-width: 768px)');
        const aplica = () => setTelaEstreita(mq.matches);
        aplica();
        if (typeof mq.addEventListener === 'function') {
            mq.addEventListener('change', aplica);
            return () => mq.removeEventListener('change', aplica);
        }
        // Safari < 14 nao tem addEventListener no MediaQueryList.
        mq.addListener(aplica);
        return () => mq.removeListener(aplica);
    }, []);
    const filtrosEmModal = Boolean(aiSearch) && telaEstreita;
    const storageHost = site?.site || (typeof window !== 'undefined' ? window.location.host : '');
    const storageCodsite = codsite || site?.id || 0;
    const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
    const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
    const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
    const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);

    const readLocalArray = (key: string) => {
        if (typeof window === 'undefined') return [];
        const value = readJsonStorageValue<any>(window.localStorage, key, []);
        return Array.isArray(value) ? value : [];
    };

    const withReadyDeliveryOption = (value: any) => {
        const options = Array.isArray(value) ? value.filter(Boolean) : [];
        const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
        const remaining = options.filter(
            (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
        );

        return [readyItem, ...remaining];
    };

        // novos estados

    const newFilter = useCallback(() => {
        // Mesma correção do modelo de busca 1 (#796): faixa da transação escolhida pode vir
        // {min:null,max:null} quando o tenant não trabalha com ela (ex.: só venda), e isso
        // deixava o slider de valores com NaN. Só vale faixa com max > 0.
        const util = (faixa: any) => (faixa && Number(faixa.max) > 0 ? faixa : null);
        const venda = util(valores?.precos_venda?.[0]);
        const locacao = util(valores?.precos_locacao?.[0]);
        const VAZIA = { min: 0, max: 0 };

        const transacao = (transacaoActual?.value || allTransacao?.[0]?.value || '').toLowerCase();
        if (transacao === 'aluguel' || transacao === 'temporada') {
            return locacao ?? venda ?? VAZIA;
        }
        return venda ?? locacao ?? VAZIA;
    }, [allTransacao, transacaoActual, valores]);
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [value2, setValue2] = React.useState<number[]>([Number(getFiltersPricess?.min ?? 0), Number(getFiltersPricess?.max ?? 0)]);
    const [minPrice, setMinPrice] = useState<number>(0);
    const [maxPrice, setMaxPrice] = useState<number>(0);

    // atualiza min/max quando muda o perfil (aluguel x venda)
    useEffect(() => {
        const next = newFilter();
        if (!next) return;

        // mantém o filterPrice (se você ainda usa em outros lugares)
        if (filterPrice.min !== next.min || filterPrice.max !== next.max) {
            setFilterPrice(next);
        }
    }, [allTransacao, filterPrice.max, filterPrice.min, newFilter, transacaoActual]);

    // handlers com clamp (mínimo não pode passar do máximo e vice-versa)
    const onMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const v = Number(raw === '' ? 0 : raw);
    setMinPrice(Number.isFinite(v) ? v : 0);
    setBuscaAvan(true);
    };

    const onMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const v = Number(raw === '' ? 0 : raw);
    setMaxPrice(Number.isFinite(v) ? v : 0);
    setBuscaAvan(true);
    };

    const onMinBlur = () => {
        setMinPrice((current) => {
            const normalized = current < 0 ? 0 : current;
            if (maxPrice > 0 && normalized > maxPrice) return maxPrice;
            return normalized;
        });
    };

    const onMaxBlur = () => {
        setMaxPrice((current) => {
            const normalized = current < 0 ? 0 : current;
            if (normalized > 0 && normalized < minPrice) return minPrice;
            return normalized;
        });
    };

    // methods
    const safeSegment = (value?: string) => {
        return value && value.trim() !== "" ? removerAcentos(hifenUrl(value, site?.id)) : "";
    };

    // MULTI-FILIAIS: preserva a filial ativa nos links de busca do hero.
    const withRegiao = useRegiaoHref();

    const renderPath = () => {
        const parts = [
            'imoveis',
            transacaoActual?.value?.toLowerCase() || allTransacao[0]?.value?.toLowerCase() || 'venda',
            safeSegment(citiesActual?.label) || '-',
            safeSegment(urlDistrict) || '-',
            safeSegment(companyActual?.label) || '-',
            safeSegment(urlTipo) || '-'
        ];

        if (codeActual) {
            parts.push(codeActual.replaceAll(' ', '%20'));
        }

        const queryParams = new URLSearchParams();
        const isEmptySite2551Search =
            Number(site?.id) === 2551 &&
            !codeActual &&
            !citiesActual?.label &&
            !urlDistrict &&
            !companyActual?.label &&
            !urlTipo &&
            !buscaAvan;

        if (buscaAvan || site?.id == 2177) {
            const normalizedMin = Math.max(0, minPrice || 0);
            const normalizedMaxRaw = Math.max(0, maxPrice || 0);
            const normalizedMax = normalizedMaxRaw > 0 && normalizedMaxRaw < normalizedMin ? normalizedMin : normalizedMaxRaw;
            if (estadoActual?.value) queryParams.set('id_estado', String(estadoActual.value));
            queryParams.set('min', String(normalizedMin));
            queryParams.set('max', String(normalizedMax));
            if (urlDatas) queryParams.set('data_entrega', String(urlDatas));
            if (showHomeCategoria && categoryActual?.value) queryParams.set('categoria', String(categoryActual.value));
            if (showHomeDormitorios) queryParams.set('dormitorios', String(dormitoriosActual?.value || 0));
            queryParams.set('banheiros', String(banheirosActual?.value || 0));
            queryParams.set('suites', String(suitesActual?.value || 0));
            queryParams.set('vagas', String(vagasActual?.value || 0));
            if (showHomeCaracteristicas && urlCaract) queryParams.set('id_caracteristica', String(urlCaract));
        }
        if (isEmptySite2551Search) {
            queryParams.set('ordem', 'desc-inclusao');
        }
        // MULTI-FILIAIS: 2+ cidades marcadas viram `?cidades=<ids>`.
        if (cidadesMulti.queryCidades) queryParams.set('cidades', cidadesMulti.queryCidades);

        let newPath = `/${parts.join('/')}`;
        if (queryParams.toString()) {
            newPath += `?${queryParams.toString()}`;
        }

        newPath = appendCodsiteQuery(newPath, _codsite2, origin);
        // MULTI-FILIAIS: a busca leva a filial ativa para a listagem (?regiao=).
        return withRegiao(newPath.toLowerCase());
    };
    // Meta Pixel: evento Search no clique de "BUSCAR" (não trava a navegação; alimenta a
    // dedup do Search CAPI da listagem via sessionStorage 'meta:searchEventId').
    const fireMetaSearch = () => {
        const transacaoNome = transacaoActual?.label || transacaoActual?.value || allTransacao[0]?.value || '';
        const tipoNome = (typesActual || []).map((t: any) => t?.label).filter(Boolean).join(', ');
        const cidadeNome = citiesActual?.label || '';
        const bairroNome = (districtActual || []).map((d: any) => d?.label).filter(Boolean).join(', ');
        const searchString = [transacaoNome, tipoNome, cidadeNome, bairroNome].filter(Boolean).join(' | ');
        const eventId = genMetaEventId();
        try { sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() })); } catch { /* sessionStorage indisponível — Search sai sem dedup c/ CAPI */ }
        trackMetaEvent(site, 'Search', {
            search_string: searchString,
            transaction_type: transacaoNome,
            property_type: tipoNome,
            city: cidadeNome,
            neighborhood: bairroNome,
        }, { eventId });
    };
    const onChangeCity = useCallback(async (txt: any) => {
        if (!txt) {
            setCitiesActual(null);
            setDistrictActual([]);
            setAllDistrict([]);
            return;
        }
        if (citiesActual?.value === txt?.value) return;
        setCitiesActual(txt);
        const infoDistrict = await district(txt.value, origin, codsite);
        setAllDistrict(formatSelects(infoDistrict?.bairros));
        setDistrictActual([]);
    }, [citiesActual?.value, codsite, origin]);
    // MULTI-FILIAIS: select de cidade multi no modo popup (ver useCidadesMulti).
    const cidadesMulti = useCidadesMulti(onChangeCity, allCitiesAux);
    // Cidade fixa na busca (CRM → Comportamento): abre o formulário já com a cidade do tenant.
    useCidadeFixaBusca(site?.cidade_busca, allCitiesAux, Boolean(citiesActual), onChangeCity);
    const onChangeDistrict = (txt: any) => {
        setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setDistrictActual(txt);
    };
    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt);
    };
    const onChangeTypes = (txt: any) => {
        setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setTypesActual(txt);
    };
    const onChangeCategory = (txt: any) => {
        if(categoryActual == txt)
            setCategoryActual([]);
        else
        setCategoryActual(txt);

        setBuscaAvan(true);
    };
    const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt)
            setEstadoActual(null);
        else{
            // selecionou um novo estado
            setEstadoActual(txt);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = useCallback(async () => {
        if(listEstados === 0 && site?.id == 2177){
            const getCondo: any = readLocalArray(listStatesStorageKey);

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem(listStatesStorageKey, JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory === 0 && showHomeCategoria){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas === 0 && showHomeCaracteristicas){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(withReadyDeliveryOption(getCondo));
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    void newItem;
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }, [codsite, listCaracteristicas, listCaracteristicasStorageKey, listCategory, listCategoryStorageKey, listDatas, listDatasStorageKey, listEstados, listStatesStorageKey, origin, setListCaracteristicas, setListCategory, setListDatas, setListEstados, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    // Carousel auto-rotation
    useEffect(() => {
        if (banners.length > 1) {
            const interval = setInterval(() => {
                setCurrentBannerIndex((prevIndex) => 
                    prevIndex === banners.length - 1 ? 0 : prevIndex + 1
                );
            }, 5000); // 5 seconds

            return () => clearInterval(interval);
        }
    }, [banners.length]);

    useEffect(() => {
        if((searchAdvanced || site?.id == 1684 || site?.id == 2146 || site?.id == 1803 || site?.id == 2177) && (showHomeCaracteristicas || showHomeCategoria || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [GetInitialFilters, searchAdvanced, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    const redirectToLink = useCallback(() => {
        const element = document.getElementById('myLink');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    useEffect(() => {
        if (allCitiesAux?.length === 1) {
            const onlyCity = allCitiesAux[0];
            if (citiesActual?.value !== onlyCity?.value) {
                onChangeCity(onlyCity);
            }
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
            redirectToLink();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
    }, [allCitiesAux, citiesActual?.value, onChangeCity, redirectToLink]);

    useEffect(() => {
        const next = newFilter();
        if(next){
            if (filterPrice.min !== next.min || filterPrice.max !== next.max) {
                setFilterPrice(next);
            }

            if (value2[0] !== next.min || value2[1] !== next.max) {
                setValue2([next.min, next.max]);
            }
        }
    }, [allTransacao, filterPrice.max, filterPrice.min, newFilter, transacaoActual, value2]);

    const renderArchives = () => {
        if (banners.length > 0 && site?.id != 1235) {
            // Caso só tenha um banner
            if (banners.length === 1) {
            const banner = banners[0];
            const imageElement = (
                <Image
                    className={styles.banner_single}
                    alt="Banner"
                    title="Banner"
                    height={1200}
                    width={1920}
                    src={banner.url.replaceAll('"', "")}
                    priority
                />
            );

            return banner.message ? 
                    banner.url_link ? (
                        <Link key={"banner"} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                            {imageElement}
                            <div className={styles.title_banner}>
                                <h1>{banner.message.toUpperCase()}</h1>
                                <button className={styles.button_banner}>CONHEÇA</button>
                            </div>
                        </Link>
                    ) : (
                    <>
                        {imageElement}
                        <div className={styles.title_banner}>
                            <h1>{banner.message.toUpperCase()}</h1>
                            <button className={styles.button_banner}>CONHEÇA</button>
                        </div>
                    </>)
                : banner.url_link ? (
                    <Link key={"banner"} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                        {imageElement}
                    </Link>
                ) : (
                    imageElement
                );
            }

            // Caso tenha mais de um banner
            return (
            <div className={styles.banner_carousel}>
                {banners.map((banner: any, index: number) => {
                    const imageElement = (
                        <Image
                            key={index}
                            className={`${styles.banner_slide} ${
                                index === currentBannerIndex ? styles.banner_active : ""
                            }`}
                            alt={`Banner ${index}`}
                            height={1200}
                            width={1920}
                            src={banner.url.replaceAll('"', "")}
                            priority={index === 0}
                        />
                    );
                
                return banner.message ? 
                    banner.url_link ? (
                        <Link key={index} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                            {imageElement}
                            <div className={styles.title_banner}>
                                <h1>{banner.message.toUpperCase()}</h1>
                                <button className={styles.button_banner}>CONHEÇA</button>
                            </div>
                        </Link>
                    ) : (
                    <>
                        {imageElement}
                        <div className={styles.title_banner}>
                            <h1>{banner.message.toUpperCase()}</h1>
                            <button className={styles.button_banner}>CONHEÇA</button>
                        </div>
                    </>)
                : banner.url_link ? (
                    <Link key={index} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                        {imageElement}
                    </Link>
                ) : (
                    imageElement
                );
                })}
            </div>
            );
        }

        // Fallback para vídeo — renderiza de imediato (sem placeholder preto) p/ o vídeo já aparecer no 1º carregamento
        // MULTI-FILIAIS: com VÍDEO REGIONAL a variante mobile `_b.mp4` não existe
        // (não geramos derivadas por filial nesta fase) — cairia em 404.
        if (isMobileView && site?.id == 1235 && !site?.url_video_regional) {
            return (
            <video
                autoPlay={!videoParado}
                muted
                loop
                height="100%"
                width="100%"
                className={styles.video_render}
                src={site?.url_video.replace(".mp4", "_b.mp4")}
                playsInline
                preload={videoParado ? 'metadata' : 'auto'}
            >
                <track kind="captions" label="Legenda" src="legenda.vtt"></track>
            </video>
            );
        }
        return (
            <video
            autoPlay={!videoParado}
            muted
            loop
            height="100%"
            width="100%"
            className={styles.video_render}
            poster={heroPoster}
            src={heroPoster ? (heroVideoReady ? site?.url_video : undefined) : site?.url_video}
            playsInline
            preload={heroPoster ? 'none' : videoParado ? 'metadata' : 'auto'}
            >
            <track kind="captions" label="Legenda" src="legenda.vtt"></track>
            </video>
        );
        };


    // LIMPAR do rodape do modal: zera os filtros e preserva a TRANSACAO (ela e' o eixo da
    // busca, nao um filtro) e o ESTADO do cs2177, que nasce fixado. `cidadesMulti.setCidades([])`
    // e' a ponte oficial do hook multi-cidades — ele chama `onChangeCity(null)`, que ja limpa
    // cidade, bairro selecionado e a lista de bairros.
    const limparFiltros = () => {
        cidadesMulti.setCidades([]);
        setCitiesActual(null);
        setDistrictActual([]);
        setAllDistrict([]);
        setTypesActual([]);
        setCaractActual([]);
        setDataEntregaActual([]);
        setCategoryActual([]);
        setCompanyActual(null);
        setCompanyInputActual('');
        setDormitoriosAtual(undefined);
        setBanheirosAtual(undefined);
        setSuitesAtual(undefined);
        setVagasAtual(undefined);
        setCodeActual('');
        setMinPrice(0);
        setMaxPrice(0);
        setUrlTipo('');
        setUrlCaract('');
        setUrlDatas('');
        setUrlDistrict('');
        setBuscaAvan(false);
    };


                {/* LINHA PRINCIPAL. Com a barra de IA o cartao nasce SO com a frase livre:
                    os filtros classicos (e o BUSCAR classico, que mora nesta <ul>) ficam
                    recolhidos ate o clique em "BUSCA AVANCADA". Sem `aiSearch` nada muda —
                    o modelo 3 dos outros 17 tenants segue igual. `display` inline porque
                    `.formGrid` e' um grid do CSS module (classe extra perderia a cascata). */}
    const camposBusca = (
                    <ul
                        className={styles.formGrid}
                        role="list"
                        style={aiSearch && !searchAdvanced ? { display: 'none' } : undefined}
                    >
                        {allTransacao?.length > 1 &&
                        <li className={styles.formItem} role="listitem">
                            <label htmlFor="home3-transacao" className={styles.visually_hidden}>Transacao</label>
                            <Select
                                inputId="home3-transacao"
                                aria-label="Transação"
                                defaultValue={allTransacao[0]?.value}
                                options={allTransacao}
                                placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value : "TRANSAÇÃO"}
                                noOptionsMessage={() => 'Processando'}
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                value={transacaoActual}
                                onChange={onChangeTransacao}
                                instanceId={1}
                                isSearchable={false}
                            />
                        </li>}

                        <li className={styles.formItem} role="listitem">
                            <label htmlFor="home3-tipo-imovel" className={styles.visually_hidden}>Tipo de imovel</label>
                            <Select
                                inputId="home3-tipo-imovel"
                                aria-label="Tipo de imóvel"
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                options={allTypes}
                                isSearchable={false}
                                isMulti
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                tabSelectsValue={false}
                                components={{ MultiValue: () => null }} // opcional, garante 0 chips
                                placeholder={typesActual?.length > 0 ? typesActual?.length > 1 ? `${typesActual?.length} Selecionados` : `1 Selecionado`: "TIPO DO IMÓVEL"}
                                value={typesActual}
                                onChange={onChangeTypes}
                            />
                        </li>

                        <li className={styles.formItem} role="listitem">
                            <label htmlFor="home3-cidade" className={styles.visually_hidden}>Cidade</label>
                            <Select
                                inputId="home3-cidade"
                                aria-label="Cidade"
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                options={allCitiesAux}
                                isSearchable
                                placeholder="CIDADE"
                                value={citiesActual}
                                onChange={onChangeCity}
                                {...cidadesMulti.selectProps}
                            />
                        </li>

                        <li className={styles.formItem} role="listitem">
                        <label htmlFor="home3-bairro" className={styles.visually_hidden}>Bairro</label>
                        <Select
                            inputId="home3-bairro"
                            aria-label="Bairro"
                            styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                            options={allDistrict}
                            isSearchable
                            isMulti
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            tabSelectsValue={false}
                            components={{ MultiValue: () => null }} // opcional, garante 0 chips
                            placeholder={districtActual?.length > 0 ? districtActual?.length > 1 ? `${districtActual?.length} Selecionados` : `1 Selecionado`: "BAIRRO"}
                            value={districtActual}
                            onChange={onChangeDistrict}
                        />
                        </li>

                        {/* Preço Mínimo */}
                        <li className={styles.formItem} style={{minWidth: "160px"}} role="listitem">
                            <input
                                id="precoMin"
                                type="number"
                                inputMode="numeric"
                                className={styles.search_input}
                                style={{ borderColor: cor_font, color: cor_font,background: "transparent" }}
                                placeholder="PREÇO MÍNIMO"
                                value={minPrice ? minPrice : ''}
                                onChange={onMinChange}
                                onBlur={onMinBlur}
                                min={0}
                                step={transacaoActual?.value === 'Aluguel' ? 100 : 1000}
                            />
                        </li>

                        {/* Preço Máximo */}
                        <li className={styles.formItem} style={{minWidth: "160px"}} role="listitem">
                            <input
                                id="precoMax"
                                type="number"
                                inputMode="numeric"
                                className={styles.search_input}
                                style={{ borderColor: cor_font, color: cor_font ,background: "transparent" }}
                                placeholder="PREÇO MÁXIMO"
                                value={maxPrice ? maxPrice : ''}
                                onChange={onMaxChange}
                                onBlur={onMaxBlur}
                                min={0}
                                step={transacaoActual?.value === 'Aluguel' ? 100 : 1000}
                            />
                        </li>

                        {/* input maior (2 colunas) */}
                        <li className={`${styles.formItem}`} style={{minWidth: "160px"}} role="listitem">
                            <input
                                className={styles.search_input}
                                type="text"
                                style={{borderColor: cor_font,color: cor_font,background: "transparent" }}
                                placeholder="BUSCA POR CÓDIGO"
                                value={codeActual}
                                onChange={onChangeCode}
                            />
                        </li>

                    {/* BUSCA AVANÇADA */}
                    {searchAdvanced && 
                        <>
                            <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={allOptions}
                                    isSearchable={false}
                                    placeholder="BANHEIROS"
                                    value={banheirosActual}
                                    onChange={onChangeBanheiros}
                                />
                            </li>

                            {showHomeDormitorios && (
                                <li className={styles.formItem} role="listitem">
                                    <Select
                                        styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                        options={allOptions}
                                        isSearchable={false}
                                        placeholder="DORMITÓRIOS"
                                        value={dormitoriosActual}
                                        onChange={onChangeDormitorios}
                                    />
                                </li>
                            )}

                            <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={allOptions}
                                    isSearchable={false}
                                    placeholder="SUÍTES"
                                    value={suitesActual}
                                    onChange={onChangeSuites}
                                />
                            </li>

                            <li className={styles.formItem} role="listitem">
                                <Select
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                options={allOptions}
                                isSearchable={false}
                                placeholder="VAGAS"
                                value={vagasActual}
                                onChange={onChangeVagas}
                                />
                            </li>

                            {site?.id == 2177 && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={listEstados}
                                    isSearchable
                                    placeholder="ESTADO"
                                    value={estadoActual}
                                    onChange={onChangeEstado}
                                />
                                </li>
                            )}

                            {showHomeCategoria && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={listCategory}
                                    isSearchable={false}
                                    placeholder="CATEGORIA"
                                    value={categoryActual}
                                    onChange={onChangeCategory}
                                />
                                </li>
                            )}

                            {showHomeCaracteristicas && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={listCaracteristicas}
                                    isSearchable={false}
                                    isMulti
                                    controlShouldRenderValue={false}
                                    hideSelectedOptions={false}
                                    tabSelectsValue={false}
                                    components={{ MultiValue: () => null }} // opcional, garante 0 chips
                                    placeholder={caractActual?.length > 0 ? caractActual?.length > 1 ? `${caractActual?.length} Selecionadas` : `1 Selecionada`: "CARACTERÍSTICAS"}
                                    value={caractActual?.length}
                                    onChange={onChangeCaracteristicas}
                                />
                                </li>
                            )}

                            { site?.exibir_empreendimento ?
                                <li className={styles.formItem} role="listitem">
                                    <Select
                                        options={allCompany}
                                        className={styles.select1}
                                        placeholder={site?.id == "1892" ? "RESIDENCIAIS E LOTEAMENTOS" : "CONDOMÍNIOS"}
                                        styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                        value={companyActual}
                                        inputValue={companyInputActual}
                                        noOptionsMessage={() =>
                                            allCompany?.length > 1 ? 'CONDOMÍNIO NÃO ENCONTRADO' : 'DIGITE O NOME DO CONDOMÍNIO'
                                        }
                                        instanceId={9}
                                        onChange={onChangeCompany}
                                        onInputChange={onInputChangeCompany}
                                    />
                                </li>
                            : null }

                            {site?.mostrar_data_entrega && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, site?.cor2)}
                                    options={listDatas}
                                    isSearchable={false}
                                    isMulti
                                    controlShouldRenderValue={false}
                                    hideSelectedOptions={false}
                                    tabSelectsValue={false}
                                    components={{ MultiValue: () => null }} // opcional, garante 0 chips
                                    placeholder={dataEntregaActual?.length > 0 ? dataEntregaActual?.length > 1 ? `${dataEntregaActual?.length} Selecionadas` : `1 Selecionada`: "DATA DE ENTREGA"}
                                    value={dataEntregaActual}
                                    onChange={onChangeDataEntrega}
                                />
                                </li>
                            )}
                        </>}
                        {/* botão */}
                        {/* BUSCAR classico. Dentro do modal ele simplesmente NAO e' renderizado:
                            o CTA de la e' o do rodape fixo, que nao sai da vista. Ocultar por
                            `style` nao bastava — a regra `.corpo li` do modal usa `!important`
                            e vencia o inline, trazendo o botao de volta no fim da lista rolavel
                            (medido: um segundo BUSCAR em y=990 numa tela de 844). */}
                        {!filtrosEmModal && (
                            <li className={`${styles.formItem}`} style={{ minWidth: 100 }} role="listitem">
                                <Link prefetch={false} href={renderPath()} onClick={fireMetaSearch}>
                                    <button className={styles.search_button}>BUSCAR</button>
                                </Link>
                            </li>
                        )}
                    </ul>
    );

    return (
        // A ancora `data-builder-section="busca"` do checklist do registry NAO entra aqui: a
        // home ja envolve o hero num <div data-builder-section="busca"> (pages/index.tsx:1480).
        // Marcar de novo criava DUAS ancoras aninhadas (medido em homologacao: 2 no lugar de 1).
        <div className={`${styles.container_adjust_text_header} ${isSite2523 ? styles.containerAdjustTextHeader2523 : ''}`}>
            <div className={`${styles.banner_container} ${isSite2523 ? styles.bannerContainer2523 : ''}`}>
                {renderArchives()}
            </div>
            <div id="myLink" style={{position: 'absolute',bottom: 350}}></div>
            {/* toggle SIMPLES/AVANCADA. Com a barra de IA (modelo_busca = 12) ele NAO aparece
                aqui em cima: o acesso a busca avancada passa a ficar ABAIXO da barra, dentro do
                cartao (mesmo gesto do hero 10). Um controle so — nao ha toggle duplicado. */}
            {!aiSearch ? (
            <div className={`${styles.search_advanced_toggle} ${isSite2523 ? styles.searchAdvancedToggle2523 : ''}`}>
                <button
                    className={searchAdvanced ? styles.advanced_button : styles.advanced_button_click}
                    onClick={() => {
                        if (!searchAdvanced) trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' });
                        setSearchAdvanced(!searchAdvanced)
                        redirectToLink()
                    }}
                    aria-expanded={searchAdvanced}
                    >
                    BUSCA SIMPLES
                </button>
                <button
                    className={searchAdvanced ? styles.advanced_button_click : styles.advanced_button}
                    onClick={() => {
                        if (!searchAdvanced) trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' });
                        setSearchAdvanced(!searchAdvanced)
                        redirectToLink()
                    }}
                    aria-expanded={searchAdvanced}
                    >
                   BUSCA AVANÇADA
                </button>
            </div>
            ) : null}
            <div className={`${styles.search_section} ${isSite2523 ? styles.searchSection2523 : ''}`}>
                <span className={`${styles.adjust_text_header} ${isSite2523 ? styles.adjustTextHeader2523 : ''}`}>
                    {site?.frase_busca ?
                    site?.id == '2112' ?
                    <motion.h1
                        alt="Título"
                        className={styles.text_header}
                        style={{fontSize: '64px', margin: '0px'}}
                        dangerouslySetInnerHTML={{
                            __html: site?.frase_busca.toUpperCase(),
                        }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0,
                            duration: 0.45,
                            ease: "easeOut"
                        }}
                    ></motion.h1>
                    :
                    <motion.h1
                        alt="Título"
                            className={styles.text_header}
                        style={site?.id == 2102 ? {fontSize: 36} : site?.id == 1992 ? {fontSize: 38} : site?.id == 2165 || site?.id == 1630 ? {fontWeight: 500} : site?.id == 1730 ? {color: "#eacba6"} : site?.id == '2127' ? {margin: 0} : site?.id == 2126 ? {color: "#ab0303",fontSize: 40} : {}}
                        dangerouslySetInnerHTML={{
                            __html: site?.id === 2177
                                ? `<span style="font-weight:100;">Descubra o Melhor do </span><span style="font-weight:bold;">Litoral Catarinense</span><span style="font-weight:100;"> e da </span><span style="font-weight:bold;">Serra Gaúcha</span>.<br>
                                    <span style="font-weight:100;">Imóveis exclusivos em </span><span style="font-weight:bold;">Itapema, Gramado e Canela</span><span style="font-weight:100;"> com a </span><span style="font-weight:bold;">confiança da Imobiliária Régis da Silveira</span>.`
                                : site?.frase_busca,
                            }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0,
                            duration: 0.45,
                            ease: "easeOut"
                        }}
                    ></motion.h1>
                    : null}
                    {site?.frase_busca_2 ?
                    <motion.h2
                        alt="Subtitulo"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0.05,
                            duration: 0.45,
                            ease: "easeOut"
                        }}
                    className={styles.text_header2} style={site?.id == 1992 ? {fontSize: 25} : site?.id == '2103' ? {fontSize: '24px', fontFamily: 'Roboto'} : site?.id == '2127' ? {fontSize: '26px'} : site?.id == '2348' ? {fontSize: '24px'} : {}}>
                        {site?.frase_busca_2}</motion.h2>
                    : null}
                </span>
               <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.08, duration: 0.45, ease: 'easeOut' }}
                    className={`${styles.search_form} ${isSite2523 ? styles.searchForm2523 : ''}`}
               >
                    {/* BUSCA POR IA (modelo_busca = 12): barra de frase livre no cartao. Igual ao
                        hero 10, os filtros classicos ficam RECOLHIDOS ate o visitante pedir a
                        busca avancada (Daniel 31/08: com os dois abertos "misturava dois modelos
                        de busca"). O que a variante preserva do modelo 3 e' o CARROSSEL de
                        banners e a POSICAO da busca — nao os filtros abertos. */}
                    {aiSearch ? (
                        <div className={styles.aiSlot}>
                            {aiSearch({
                                transacao: String(transacaoActual?.value || allTransacao?.[0]?.value || 'venda').toLowerCase(),
                                filtrosAbertos: Boolean(searchAdvanced),
                                onTransacaoChange: (value) => {
                                    const opt = (allTransacao || []).find(
                                        (t) => String(t?.value || '').toLowerCase() === String(value || '').toLowerCase()
                                    );
                                    if (opt) onChangeTransacao(opt);
                                },
                            })}
                        </div>
                    ) : null}
                    {/* Os campos saem em um de dois lugares: inline no cartao (desktop, e todo
                        tenant que nao usa a barra de IA) ou dentro do modal de tela cheia no
                        celular. E' o MESMO `camposBusca` — mesmo estado, mesmo `renderPath()`;
                        o modal troca o CONTINENTE, nao o conteudo. */}
                    {filtrosEmModal ? (
                        <FiltrosModalMobile
                            aberto={Boolean(searchAdvanced)}
                            onFechar={() => setSearchAdvanced(false)}
                            corFundo={site?.cor5}
                            corTexto={cor_font}
                            hrefBuscar={renderPath()}
                            aoBuscar={() => {
                                fireMetaSearch();
                                setSearchAdvanced(false);
                            }}
                            aoLimpar={limparFiltros}
                        >
                            {camposBusca}
                        </FiltrosModalMobile>
                    ) : camposBusca}
                    {/* ACESSO A BUSCA AVANCADA (modelo_busca = 12): fica ABAIXO da barra de IA,
                        no rodape do cartao — e' o MESMO estado `searchAdvanced` do toggle de cima
                        (que some nesta variante), entao nao ha dois controles disputando. Rotulo
                        alterna igual ao hero 10: "BUSCA AVANCADA" recolhido / "BUSCA SIMPLES"
                        aberto. Sem `aiSearch` nao renderiza nada — modelo 3 intacto. */}
                    {aiSearch ? (
                        <div className={styles.aiToggle}>
                            <button
                                type="button"
                                className={styles.advanced_button}
                                onClick={() => {
                                    if (!searchAdvanced) trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' });
                                    setSearchAdvanced(!searchAdvanced);
                                }}
                                aria-expanded={Boolean(searchAdvanced)}
                            >
                                {searchAdvanced ? 'BUSCA SIMPLES' : 'BUSCA AVANÇADA'}
                            </button>
                        </div>
                    ) : null}
                </motion.div>

                <CardsBusca cards={allCards} site={site} variante="escuro" />
            </div>

            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                menus={props?.menus}
            />
        </div>
    );
};

export default WelcomePieces;
